import { ApiKey } from "../apiKeys";
import { authAxios, publicAxios } from "../config";
import dayjs from "dayjs";
import { checkTokenValidation } from "../auth/tokenReq";

export const fetchUserDetailsReq = async (data: {
  mobileNumber: string | number;
  email: string;
  PhoneCountryCode: number;
}) => {
  const logfun = (d: any, t: string) =>
    console.log(d, new Date() + ": deleteUserReq->fetchUserDetailsReq " + t);
  try {
    await checkTokenValidation();
    const body = {
      email: data.email,
      mobileNumber: data.mobileNumber,
      PhoneCountryCode: data.PhoneCountryCode.toString(),
    };
    const res = await authAxios.post(
      `${ApiKey.fetchCandidateDetailsKey}`,
      body
    );
    console.log("res", res);
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message;
    // Backend returns { message, data: {...} }
    const userData = resData?.data || resData;

    // Map roleID to userType string
    const roleIdToType: { [key: number]: string } = {
      200: "Candidate",
      301: "E-Admin",
      302: "Recruiter",
      102: "CEP",
      101: "PAdmin",
    };

    const _data = {
      email: userData?.email || "",
      mobileNumber: userData?.mobileNumber || "",
      PhoneCountryCode: userData?.PhoneCountryCode || 0,
      candidateName: `${userData?.firstName || ""} ${userData?.lastName || ""}`.trim(),
      companyName: userData?.CompanyName || "",
      userType: roleIdToType[userData?.roleID] || "Unknown",
      offers: [],
    };
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err?.response?.data?.message || "Response Error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const deleteUserDetailsReq = async (data: {
  mobileNumber: string | number;
  email: string;
  PhoneCountryCode: number;
}) => {
  const logfun = (d: any, t: string) =>
    console.log(d, new Date() + ": deleteUserReq->deleteUserDetailsReq " + t);
  try {
    const FMCToken = localStorage.getItem("@deviceToken");
    const body = {
      email: data.email,
      mobileNumber: data.mobileNumber,
      PhoneCountryCode: data.PhoneCountryCode,
    };
    const res = await authAxios.post(
      `${ApiKey.deleteCandidateDetailsKey}`,
      body
    );
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message;
    return { error: false, data: "", message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err?.response?.data?.message || "Response Error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};
